import { Staffs } from '~reducers';
import { GetTables_Venue_floorPlans_tables } from '~Scenes/Venue/__queries__/GetTables';

export const buildSearchableTableEvents = (
  eventList: any[],
  staff: Staffs,
  tables: GetTables_Venue_floorPlans_tables[],
) => {
  return eventList.map((event: any) => {
    const staffName = staff?.find((s) => s.id === event.staffId)?.name;
    const tableCode = tables?.find((t) => t.id === event.tableId)?.code;
    const eventName = event?.type?.replace('_', ' ');

    return {
      ...event,
      staffName,
      tableName: `Table ${tableCode}`,
      itemName: event.title,
      eventName,
    };
  });
};

export const prettifyString = (str = ''): string => {
  return str
    .toLowerCase()
    .split('_')
    .map((word) => word[0]?.toUpperCase() + word.slice(1))
    .join(' ');
};

export const buildSearchableReportEvents = (eventList: any[] = []) => {
  return eventList.map((event) => {
    const client = prettifyString(event?.clientId);
    const action = prettifyString(event.type);
    return { ...event, action, client };
  });
};
